import { Dispatch } from 'redux';
import { setLoadedDirectSalesDataWithPublisherDefaults } from 'store/dealManagement/actions/setLoadedDirectSalesData';
import { changeActiveDirectSalesLine, changeDealData } from 'store/dealManagement/reducer';
import {
  FindSavedLineIdArgs,
  NextDealIdArgs,
  PostSaveCampaign,
  SelectRefreshedLinesArgs,
  UpdateStoredDealIdArgs,
} from './campaignPostSaveRefresh.types';
import { isDirectSalesCampaignCloned } from './isDirectSalesCampaignCloned';

const getNextDealId = ({
  updateDealId,
  currentCampaignId,
  resultingCampaignId,
  campaign,
}: NextDealIdArgs): string | undefined => {
  if (updateDealId === 'whenSaveResultDiffers' && resultingCampaignId && resultingCampaignId !== currentCampaignId) {
    return resultingCampaignId;
  }

  if (updateDealId === 'whenFetchedCampaignIdDiffers' && campaign.id !== currentCampaignId) {
    return campaign.id;
  }

  const fetchedHeaderId = campaign.campaign.header?.id;

  if (
    updateDealId === 'whenFetchedHeaderIdDiffers' &&
    resultingCampaignId &&
    fetchedHeaderId &&
    resultingCampaignId !== fetchedHeaderId
  ) {
    return fetchedHeaderId;
  }

  return undefined;
};

export const findSavedLineId = ({
  savedLineMatch,
  campaign,
  savedLineName,
  savedLineId,
}: FindSavedLineIdArgs): string | undefined => {
  if (savedLineMatch === 'skip') return undefined;

  const dealLines = campaign.campaign.body.campaignDefinition?.dealLines ?? [];
  const savedLine =
    savedLineMatch === 'byName'
      ? dealLines.find(({ name }) => name === savedLineName)
      : dealLines.find(({ id }) => id === savedLineId);

  return savedLine?.id;
};

export const storeLoadedCampaign = (dispatch: Dispatch, campaign: PostSaveCampaign): void => {
  dispatch(setLoadedDirectSalesDataWithPublisherDefaults({ commonDeal: campaign.deal, lines: campaign.lines }));
};

export const updateStoredDealId = ({
  dispatch,
  settings,
  currentCampaignId,
  resultingCampaignId,
  campaign,
  onCampaignTransient,
}: UpdateStoredDealIdArgs): void => {
  const nextDealId = getNextDealId({
    updateDealId: settings.updateDealId,
    currentCampaignId,
    resultingCampaignId,
    campaign,
  });

  if (!nextDealId) return;

  dispatch(changeDealData({ dealId: nextDealId }));

  if (settings.shouldShowTransientBanner && isDirectSalesCampaignCloned(nextDealId)) onCampaignTransient?.();
};

export const selectRefreshedLines = ({
  dispatch,
  settings,
  campaign,
  foundSavedLineId,
  activeLineId,
}: SelectRefreshedLinesArgs): void => {
  if (foundSavedLineId && settings.updateCampaignInStore === 'whenSavedLineFound') {
    storeLoadedCampaign(dispatch, campaign);
  }

  if (foundSavedLineId && settings.selectActiveLine === 'savedLine') {
    dispatch(changeActiveDirectSalesLine(foundSavedLineId));
  }

  if (settings.selectActiveLine === 'providedLine' && activeLineId) {
    dispatch(changeActiveDirectSalesLine(activeLineId));
  }
};
